import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import BetalingModal from "./BetalingModal";
import { useEffect } from "react";

const BoekingsregelsTabel = ({ boekingsregels, betalingen }) => {
  const [selectedBetaling, setSelectedBetaling] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [betaling, setBetaling] = useState(null);
  useEffect(() => {
    if (boekingsregels && boekingsregels.length > 0) {
      const betalingIds = boekingsregels.map((regel) => regel.betaling).filter(Boolean);
      const uniqueBetalingIds = [...new Set(betalingIds)];
      const betalingenData = uniqueBetalingIds.map((id) => betalingen.find((b) => b.id === id));
      setBetaling(betalingenData);
    }
  }, [boekingsregels, betalingen]);

  const openModal = (betalingId) => {
    const betaling = betalingen.find((b) => b.id === betalingId);
    if (betaling) {
      setSelectedBetaling(betaling);
      setModalVisible(true);
    }
  };

  const isbetaald = (regel) => {
    if (regel.betaling) {
      const betaling = betalingen.find((b) => b.id === regel.betaling);
      return betaling ? betaling.status === "paid" : false;
    }
    return false;
  };
  return (
    <div className="container my-4">
      <table className="table table-striped table-bordered table-hover">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Product</th>
            <th>Waarde</th>
            <th>Prijs</th>
            <th>Door</th>
            <th>Betaald</th>
            <th>Betaling</th>
          </tr>
        </thead>
        <tbody>
          {boekingsregels.map((regel, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{regel.product}</td>
              <td>{regel.value}</td>
              <td>€ {parseFloat(regel.prijs).toFixed(2)}</td>
              <td>{regel.door}</td>
              <td>{isbetaald(regel) ? <span className="badge bg-success">Ja</span> : <span className="badge bg-danger">Nee</span>}</td>
              <td>
                {regel.betaling ? (
                  <button className="btn btn-link p-0" onClick={() => openModal(regel.betaling)}>
                    {regel.betaling}
                  </button>
                ) : (
                  "-"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <BetalingModal visible={modalVisible} onClose={() => setModalVisible(false)} betaling={selectedBetaling} />
    </div>
  );
};

export default BoekingsregelsTabel;
